import React from "react";
import "../Css/Technologies.css";

export default function Technologies() {
  const technologies = [
    { name: "JavaScript", image: "/images/js.png" },
    { name: "Python", image: "/images/python.png" },
    { name: "PHP", image: "/images/php.png" },
    { name: "Java", image: "/images/java.png" },
    { name: "React", image: "/images/react.png" },
    { name: "Node", image: "/images/node.png" },
    { name: "Angular", image: "/images/angular.png" },
    { name: "Express", image: "/images/express.png" },
    { name: "Laravel", image: "/images/laravel.png" },
    { name: "React Native", image: "/images/react-native.png" },
    { name : "Shopify", image: "/images/shopify.png" },
    { name: "WordPress", image: "/images/wordpress.png" },
    { name: "magento", image: "/images/magento.png" },
    { name: "AWS", image: "/images/aws.png" },
    { name: ".NET", image: "/images/dotnet.png" },
    { name: "Google Cloud", image: "/images/google-cloud.png" },
    { name: "Saleforce", image: "/images/salesforce.png" },
    { name:"Azure", image: "/images/azure.png"},
    
  ];

  // Duplicate for seamless loop
  const loopTechs = [...technologies, ...technologies];

  return (
    <div className="container-fluid d-flex align-items-center justify-content-center">


      <div className="container">
        <div className="row">
          <div className="col-12 text-center mb-5">
            <h1 className="fw-bold mb-3">
              Our<span style={{borderBottom:'5px solid #9374FF'}}> Tech Stacks</span>
            </h1>
            <p className="subtitle mb-0">
              We are expertise in the latest cutting-edge technologies.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="scroll-container">
              <div className="scroll-content">
                {loopTechs.map((tech, index) => (
                  <div key={index} className="tech-badge">
                    <img src={tech.image} alt={tech.name} className="tech-icons" />
                    <span className="tech-name">{tech.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
